import React from 'react';
import { useQuery } from '@apollo/client';
import {
  GET_DASHBOARD,
  GET_SUMMARY,
  GET_DASHBOARD_ESTIMATE,
} from '../graphql/Dashboard';
import { EMPLOYEES } from '../graphql/Employee';
import { generateArrayOfYears } from '../utils';

const defaultDashboard = [
  {
    total_base_price: 0,
    total_sales: 0,
    total_profit: 0,
    total_discount: 0,
    total_platform_fee_bill: 0,
    total_platform_fee_invoice: 0,
    total_delivery_fee: 0,
    quarterly: 1,
  },
  {
    total_base_price: 0,
    total_sales: 0,
    total_profit: 0,
    total_discount: 0,
    total_platform_fee_bill: 0,
    total_platform_fee_invoice: 0,
    total_delivery_fee: 0,
    quarterly: 2,
  },
  {
    total_base_price: 0,
    total_sales: 0,
    total_profit: 0,
    total_discount: 0,
    total_platform_fee_bill: 0,
    total_platform_fee_invoice: 0,
    total_delivery_fee: 0,
    quarterly: 3,
  },
];

const defaultSummary = {
  total_order: 0,
  new_order: 0,
  process_order: 0,
  done_order: 0,
};

const defaultEstimate = [
  { estimate_total_sales: 0, estimate_profit: 0, quarterly: 1 },
  { estimate_total_sales: 0, estimate_profit: 0, quarterly: 2 },
  { estimate_total_sales: 0, estimate_profit: 0, quarterly: 3 },
];

const useDashboard = () => {
  const [year, setYear] = React.useState(new Date().getFullYear());
  const [employee, setEmployee] = React.useState(0);

  const [dashboard, setDashboard] = React.useState(defaultDashboard);
  const [summary, setSummary] = React.useState(defaultSummary);
  const [dashboardEstimate, setDashboardEstimate] = React.useState(defaultEstimate);
  const [employees, setEmployees] = React.useState([]);

  const years = React.useMemo(() => generateArrayOfYears(), []);

  const { data: dataDashboard, loading: loadingDashboard } = useQuery(
    GET_DASHBOARD,
    {
      variables: { year, employee_id: employee },
      fetchPolicy: 'network-only',
      onError: (e) => console.log('error getting dashboard:', e),
    },
  );

  const { data: dataSummary, loading: loadingSummary } = useQuery(
    GET_SUMMARY,
    {
      variables: { year, employee_id: employee },
      fetchPolicy: 'network-only',
      onError: (e) => console.log('error getting summary:', e),
    },
  );

  const { data: dataDashboardEstimate, loading: loadingEstimate } = useQuery(
    GET_DASHBOARD_ESTIMATE,
    {
      variables: { year, employee_id: employee },
      fetchPolicy: 'network-only',
      onError: (e) => console.log('error getting dashboard estimate:', e),
    },
  );

  const { data: dataEmployees, loading: loadingEmployees } = useQuery(
    EMPLOYEES,
    {
      fetchPolicy: 'network-only',
      onError: (e) => console.log('error getting employees:', e),
    },
  );

  React.useEffect(() => {
    if (dataDashboard?.getTotalDashboard?.length) {
      setDashboard(dataDashboard.getTotalDashboard);
    }
  }, [dataDashboard]);

  React.useEffect(() => {
    if (dataSummary?.getSummary) {
      setSummary(dataSummary.getSummary);
    }
  }, [dataSummary]);

  React.useEffect(() => {
    if (dataDashboardEstimate?.getDashboardEstimate) {
      setDashboardEstimate(dataDashboardEstimate.getDashboardEstimate);
    }
  }, [dataDashboardEstimate]);

  React.useEffect(() => {
    if (dataEmployees?.employees) {
      setEmployees(dataEmployees.employees);
    }
  }, [dataEmployees]);

  const isLoading =
    loadingDashboard ||
    loadingSummary ||
    loadingEstimate ||
    loadingEmployees;

  return {
    year,
    setYear,
    employee,
    setEmployee,
    years,
    employees,
    dashboard,
    summary,
    dashboardEstimate,
    isLoading,
  };
};

export default useDashboard;
